import { render, staticRenderFns } from "./jkyAdminSelect.vue?vue&type=template&id=2178c758&scoped=true"
import script from "./jkyAdminSelect.vue?vue&type=script&lang=js"
export * from "./jkyAdminSelect.vue?vue&type=script&lang=js"
import style0 from "./jkyAdminSelect.vue?vue&type=style&index=0&id=2178c758&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2178c758",
  null
  
)

export default component.exports